import React from 'react'
import List from './list'
import Create from './create'
import Stack from '@mui/material/Stack'
import VendorPicker from "../../components/vendorPicker"
const SaleEvents = () => {
  return (
    <Stack
      direction="column"
      justifyContent="space-evenly"
      alignItems="center"
      spacing={2}
    >
      <VendorPicker/>
      <List/>
    </Stack>
  )
}

export default SaleEvents;